<template>
  <div class="navbar">
    <!-- <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" /> -->
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <!-- <top-nav v-if="settingsStore.topNav" id="topmenu-container" class="topmenu-container" /> -->

    <div class="right-menu">
      <div class="theme-switch-wrapper" @click="switchTheme($event, 'theme-dark')"
        v-if="settingsStore.currentTheme == 'theme-light'">
        <svg-icon icon-class="theme_dark" />
      </div>
      <div class="theme-switch-wrapper" @click="switchTheme($event, 'theme-light')" v-else>
        <svg-icon icon-class="theme_light" />
      </div>
      <el-dropdown @command="handleCommand" class="avatar-container right-menu-item">
        <div class="avatar-wrapper">
          <img :src="userStore.avatar" class="user-avatar" />
          <span class="user-nickname"> {{ userStore.nickName }} </span>
          <div class="right-menu-item">
            <svg-icon icon-class="more_up" />
          </div>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <router-link to="/user/profile">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>
            <!-- <el-dropdown-item command="setLayout" v-if="settingsStore.showSettings">
              <span>布局设置</span>
            </el-dropdown-item> -->
            <el-dropdown-item divided command="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

    </div>
  </div>
</template>

<script setup>
import { ElMessageBox } from 'element-plus'
import Breadcrumb from '@/components/Breadcrumb'
// import TopNav from '@/components/TopNav'
// import Hamburger from '@/components/Hamburger'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import HeaderSearch from '@/components/HeaderSearch'
// import RuoYiGit from '@/components/RuoYi/Git'
// import RuoYiDoc from '@/components/RuoYi/Doc'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import { userInfoUpdateTheme } from '@/api/system/user'

const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()

// function toggleSideBar() {
//   appStore.toggleSideBar()
// }

function switchTheme(e, theme) {
  // console.log('🎯 触发主题切换:', theme);

  userInfoUpdateTheme({ themeMode: theme }).then((res) => {
    if (res.code == 200) {
      // 在 startViewTransition 内部切换主题，确保动画生效
      const transition = document.startViewTransition(() => {
        // 更新 store 状态，这会切换主题类名
        settingsStore.toggleTheme();
        // console.log('🔄 主题类名已切换');
      });

      // 等待过渡准备就绪后执行动画
      setTimeout(async () => {
        await transition.ready;
        // console.log('✅ 过渡准备就绪');

        // 重新获取事件对象
        const eventObj = e || {
          clientX: window.innerWidth / 2,
          clientY: window.innerHeight / 2
        };

        const x = eventObj.clientX;
        const y = eventObj.clientY;
        const endRadius = Math.hypot(
          Math.max(x, innerWidth - x),
          Math.max(y, innerHeight - y)
        );

        // console.log('📍 点击位置:', { x, y });
        // console.log('🔵 半径:', endRadius);

        // Element Plus 官方实现方式：
        // 始终只对新视图执行扩散动画，通过 CSS 的 z-index 控制层级
        // 亮色 -> 暗黑：新视图（暗黑）在上方扩散
        // 暗黑 -> 亮色：新视图（亮色）在上方扩散
        document.documentElement.animate(
          {
            clipPath: [
              `circle(0px at ${x}px ${y}px)`,
              `circle(${endRadius}px at ${x}px ${y}px)`
            ]
          },
          {
            duration: 500,
            easing: 'ease-in',
            pseudoElement: '::view-transition-new(root)'
          }
        );

        // console.log('🎬 动画已开始');
      }, 0);
    }
  })
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      // setLayout()
      break
    case "logout":
      logout()
      break
    default:
      break
  }
}

function logout() {
  let { VITE_APP_ENV } = import.meta.env;
  ElMessageBox.confirm('确定注销并退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    userStore.logOut().then(() => {
      let href = VITE_APP_ENV == 'production' ? userStore.homePage : '/vpp-web' + userStore.homePage;
      location.href = href;
    })
  }).catch(() => { })
}

const emits = defineEmits(['setLayout'])
function setLayout() {
  emits('setLayout')
}
</script>

<style lang='scss' scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  overflow: hidden;
  position: relative;
  margin: 0 24px 8px 24px;

  .el-breadcrumb {
    :deep(.el-breadcrumb__item) {
      .el-breadcrumb__inner {
        .redirect {
          font-family: pingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: var(--layout-text-color);
        }

        .no-redirect {
          color: var(--layout-text-color1);
          font-family: pingFangSC-Regular;
        }

        .no-redirect:last-child {
          color: var(--layout-text-color2);
        }
      }
    }
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    align-items: center;
    height: 100%;

    .theme-switch-wrapper {
      display: inline-flex;
      padding: 5px;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid var(--layout-svgImg-border-color);
      margin-right: 16px;

      .svg-icon {
        font-size: 14px;
        color: var(--layout-svgImg-icon-color);
      }
    }

    .avatar-container {

      .avatar-wrapper {
        display: flex;
        align-items: center;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          user-select: none;
          border: 1px solid var(--userImg-border-color);
        }

        .user-nickname {
          font-family: pingFangSC-Medium;
          font-size: 14px;
          color: var(--userName-text-color);
          margin: 0 4px;
        }
      }
    }

    .right-menu-item {
      cursor: pointer;

      .svg-icon {
        width: 14px;
        color: var(--layout-svgImg-icon-color);
      }
    }
  }
}
</style>